import { Box, Chip, Dialog, DialogContent, Typography } from '@mui/material';
import { useForm } from 'react-hook-form';
import { Icon } from '@iconify/react';
import CustomTextField from '../../../../../common/components/customized/customtextfield/CustomTextField';
import { useGeofenceSearchVehicle } from '../hooks/geofenceSearch';
import constants from '../../../../../utils/constants';
import './CustomViewCard.scss';

const CustomViewCard = ({ viewEye, setViewEye, cardData }: any) => {
  const { control } = useForm();
  const { onClose, handleSearchMappedVehicle, searchVehicle } = useGeofenceSearchVehicle({
    setViewEye,
    cardData
  });
  return (
    <>
      <Dialog
        open={viewEye ? true : false}
        className='view-vehicle-container'
        maxWidth={'xs'}
        onClose={onClose}
      >
        <DialogContent>
          <Box className='dialog-vehicle-content'>
            <Box>
              <Icon
                className='vehicle-mapping-icon'
                icon='mingcute:close-circle-fill'
                onClick={onClose}
              />
            </Box>

            <Box className='mapping-headings-vehicle'>
              <Typography className='vehicle-title'>
                {constants.MappedVehicles}
              </Typography>
              <CustomTextField
                id='geofence-name'
                control={control}
                name='searchFilterVehicle'
                placeholder='Search...'
                onChangeCallback={(e: any) => {
                  handleSearchMappedVehicle(e);
                }}
              />
            </Box>
            <Box
              className={`mapping-vehicles ${
                searchVehicle.length > 0 ? 'col-items' : 'inline-items'
              }`}
            >
              {searchVehicle.length > 0 ? (
                searchVehicle?.map((value: any, index: number) => (
                  <Chip
                    className='vehicle-chip'
                    key={index}
                    size='small'
                    label={value?.toUpperCase()}
                  />
                ))
              ) : (
                <Box className='vehicle-no-found'>
                  <Typography>{constants.NoDataFound}</Typography>
                </Box>
              )}
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default CustomViewCard;
